/**
 * Facade for attio-operation.ts functions
 * Provides backward compatibility while using the new modular services
 */
import { attioService } from './attio';

// Re-export functions from attio-operation.ts using the new services
export const getAttioTeamMemberDetail = (teamRecordId: string) =>
  attioService.consultants.getOtherConsultant(teamRecordId);

export const getAttioPeopleDetail = (peopleRecordId: string) => attioService.people.getPeopleDetail(peopleRecordId);

export const getAttioWorkspaceMemberDetail = (workspaceMemberRecordId: string) =>
  attioService.engagement.getEngagementManager(workspaceMemberRecordId);

export const getAttioDealDetail = (dealRecordId: string) => attioService.deals.getDealDetail(dealRecordId);

export const getAttioValuationDetail = (valuationRecordId: string) =>
  attioService.valuationDetails.getValuationDetail(valuationRecordId);

export const getAttioNotesForValuation = (records: Array<{ parentObject: string; parentRecordId: string; prefix: string }>) => 
  attioService.notes.getNotesForValuation(records);

export const getAttioCompanyData = (attioCompanyId: string) =>
  attioService.companies.getCompanyByEntityRecordId(attioCompanyId);

export const getAttioValuationByRecordId = (valuationRecordId: string) =>
  attioService.valuationDetails.getValuationByRecordId(valuationRecordId);
